import React from 'react';
import styled from 'styled-components';
import PropTypes from 'prop-types';
import { convertToTitleCase } from 'lib/utils';
import { Field } from 'react-final-form';
import {
  CircularProgress,
  MenuItem as MuiMenuItem,
  Select as MuiSelect,
} from '@mui/material';
import { ExpandMore as ExpandMoreIcon } from '@mui/icons-material';

import SValidationError from 'components/styled/SValidationError';

const FormSelect = (props) => {
  const { name, options, getItemId, getItemName, getValue = (v) => v } = props;
  return options ? (
    <Field name={name}>
      {({ input, meta }) => {
        return (
          <>
            <SSelect
              {...props}
              variant="outlined"
              size="small"
              value={input?.value}
              IconComponent={() => <ExpandMoreIcon />}
            >
              {options?.map((item) => (
                <SMuiMenuItem
                  key={getItemId(item)}
                  value={
                    item?.id === input?.value?.id ||
                    item?.code === input?.value?.code
                      ? input?.value
                      : item
                  }
                  selected={
                    item?.id === input?.value?.id ||
                    item?.code === input?.value?.code
                  }
                  onClick={() => input.onChange(getValue(item))}
                >
                  {convertToTitleCase(getItemName(item))}
                </SMuiMenuItem>
              ))}
            </SSelect>
            {meta.error && <SValidationError>{meta.error}</SValidationError>}
          </>
        );
      }}
    </Field>
  ) : (
    <CircularProgress
      size={25}
      sx={{ display: 'flex', justifyContent: 'center' }}
    />
  );
};

const SSelect = styled(MuiSelect)`
  overflow: hidden;
  height: 40px;
  width: 100%;
  border-radius: 5px;

  .MuiSvgIcon-root {
    margin-right: 5px;
  }
  .MuiSelect-outlined.MuiSelect-outlined {
    padding: 0 10px;
  }
  .MuiInputLabel-outlined {
    top: -8px;
    color: ${({theme}) => theme.palette.colors.gray400};
  }
  fieldset {
    legend {
      max-width: 0;
    }
  }
`;

const SMuiMenuItem = styled(MuiMenuItem)`
  min-height: 40px;
`;

export default FormSelect;

FormSelect.propTypes = {
  name: PropTypes.string.isRequired,
  options: PropTypes.array.isRequired,
  getItemId: PropTypes.func.isRequired,
  getItemName: PropTypes.func.isRequired,
  label: PropTypes.string,
};
